// extracted by mini-css-extract-plugin
export default {"card":"Card_card__T2bEZ","expanded":"Card_expanded__kSI5p"};